import styled from 'styled-components';
import theme from 'common/theme';

export const labelWithColoredCirclesStyles = <{color?: string, colorr?: string}>`
    background-color: transparent;
    padding: 0;
    font-family: inherit;
    font-weight: 400;
    border: none;
    width: max-content;
    text-transform: capitalize;
    font-size: 1em;
    cursor: pointer;
    padding-right: 1em;
    white-space: nowrap;
  
    display: flex;
    gap: .3em;
    display: inline-flex;
    align-items: center;

    .value,
    .sub-text {
      font-size: .9em;
      color: ${theme.colors.label};
    }
    
    .colored-circle {
      width: .8em;
      height: .8em;
      border-radius: 50%;
      display: inline-block;
    }
  
    &.is-filtered {
      opacity: 0.7;
    }
  
    &.item--average {
      background: repeating-linear-gradient(
        90deg,
        transparent,
        transparent 10px,
        #333 10px,
        #333 15px
      );
    }
 
`;

export const LabelWithColoredCircleContainer = styled.button<{ color?: string, colorr?: string }>`
  ${labelWithColoredCirclesStyles}

  ${({ color }) =>
      color
        ? `
  
      &:before {
        content: '';
        width: .8em;
        height: .8em;
        border-radius: 50%;
        display: block;
        background-color: ${color};
      }
  
    `
        : ``}

  &.is-filtered {
    opacity: 0.7;
  }
`;
